<template>
  <button
    class="control-button"
    @click="$emit('click')"
    :aria-label="isPlaying ? t('player.controls.pause') : t('player.controls.play')"
    :data-tooltip="(isPlaying ? t('player.controls.pause') : t('player.controls.play')) + ' (k)'"
    v-html="isPlaying ? pauseIcon : playIcon"
  />
</template>

<script setup lang="ts">
import { playIcon, pauseIcon } from '../../assets/icons'
import { useVideoI18n } from '../../i18n'

defineProps<{ isPlaying: boolean }>()
defineEmits<{ click: [] }>()

const { t } = useVideoI18n()
</script>

<style scoped lang="scss">
/* Styles in main.scss > _control-buttons.scss */
</style>
